// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  RedisJobStatus,
  RedisQuery,
  RedisQueryAPIPayload,
} from '@shared/types/redis';
import { transformResponse } from '@utilities/api';
import { redisQuery } from '@utilities/fetchRedisQuery';

// Define a service using a base URL and expected endpoints
export const redisApi = createApi({
  baseQuery: redisQuery,
  endpoints: (builder) => ({
    /**
     * Enqueue Job
     */
    enqueueJob: builder.mutation<RedisQuery, RedisQueryAPIPayload>({
      query: ({ job, args, queue }) => ({
        url: `/enqueue-job`,
        method: 'POST',
        body: { job, args, queue },
      }),
      transformResponse,
    }),

    /**
     * Get Job
     */
    getJobStatus: builder.query<RedisJobStatus, string | undefined>({
      query: (jobId) => ({
        url: `/job-status/${jobId}`,
        method: 'GET',
      }),
      transformResponse,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useEnqueueJobMutation, useGetJobStatusQuery } = redisApi;
